import type { FC, JSX } from "react";

export type UserMenuOptionProps = {
	label: string;
	Icon: JSX.ElementType;
};

export const UserMenuOption: FC<UserMenuOptionProps> = ({ label, Icon }) => (
	<div className="flex space-x-[10px] items-center text-[14px] w-full min-w-[200px] font-medium px-[20px] py-[12px] text-gray-800 hover:underline">
		<Icon className="text-[16px] text-secondary stroke-[1.75]" />
		<span data-testid="menu-option-label">{label}</span>
	</div>
);
